import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { isLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
// importing this module into itself. We need to reference canMessageBrand as
// MessageBrandCTAUtils.canMessageBrand in this file so that it can be properly
// mocked
import * as MessageBrandCTAUtils from "@faire/retailer-visitor-shared/lib/messageBrandCTAUtils";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { MessengerFactory, useMessengerFactory } from "@faire/retailer-visitor-shared/stores/MessengerFactory";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import confirmIdentity from "@faire/web-api--source/routes/confirm-identity";
import messages from "@faire/web-api--source/routes/messages/otherPartyToken";
import { useMutation } from "@tanstack/react-query";
export var useContactBrand = function(brand) {
    var retailer = useRetailer().retailer;
    if ((retailer === null || retailer === void 0 ? void 0 : retailer.identity_confirmed) && canMessageBrand(brand)) {
        return function() {
            var _getWindow;
            var _brand_token;
            return (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.open(messages((_brand_token = brand === null || brand === void 0 ? void 0 : brand.token) !== null && _brand_token !== void 0 ? _brand_token : ""), "_blank");
        };
    }
    return undefined;
};
export var canMessageBrand = function(brand) {
    return !!(isLoggedInRetailerOrBrandPreview() && (brand === null || brand === void 0 ? void 0 : brand.token) && brand.active && !brand.hide_chat && MessengerFactory.get().messengerStore.getConversationByBrand(brand.token));
};
export var showMessageBrandCTA = function(brand) {
    var _RetailerStore_get_retailer;
    return MessageBrandCTAUtils.canMessageBrand(brand) || !((_RetailerStore_get_retailer = RetailerStore.get().retailer) === null || _RetailerStore_get_retailer === void 0 ? void 0 : _RetailerStore_get_retailer.identity_confirmed);
};
export var showVerificationTooltip = function(brand) {
    var _RetailerStore_get_retailer;
    return !MessageBrandCTAUtils.canMessageBrand(brand) && !((_RetailerStore_get_retailer = RetailerStore.get().retailer) === null || _RetailerStore_get_retailer === void 0 ? void 0 : _RetailerStore_get_retailer.identity_confirmed);
};
export var getUnverifiedRetailerTooltipLabels = function(strictLocalize) {
    return {
        title: strictLocalize({
            id: "0usTCx",
            defaultMessage: [
                {
                    type: 0,
                    value: "Your account is in review"
                }
            ]
        }),
        message: strictLocalize({
            id: "VTAFLg",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sorry, only verified accounts can message this brand directly. All retailers go through our review process\u2014once your account is confirmed, you'll be able to message this brand."
                }
            ]
        })
    };
};
export var getIdvTransparencyMessage = function(strictLocalize, pendingIdv) {
    if (pendingIdv) {
        if (UserStore.get().isRetailerSubUser) {
            return {
                messageLabel: strictLocalize({
                    id: "8mUDde",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "To message brands, please have your account owner verify your team account."
                        }
                    ]
                }),
                action: undefined
            };
        }
        return {
            messageLabel: strictLocalize({
                id: "N6SI8E",
                defaultMessage: [
                    {
                        type: 0,
                        value: "To message brands, please verify your account."
                    }
                ]
            }),
            action: {
                label: strictLocalize({
                    id: "ErG9su",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Verify Account"
                        }
                    ]
                }),
                link: confirmIdentity()
            }
        };
    } else {
        return {
            messageLabel: strictLocalize({
                id: "/RAasD",
                defaultMessage: [
                    {
                        type: 0,
                        value: "You\u2019ll be able to message brands as soon as your account is verified. We\u2019re reviewing your info now."
                    }
                ]
            }),
            action: undefined
        };
    }
};
export var useSetMessengerBrandContext = function() {
    var messengerStore = useMessengerFactory([
        "messengerStore"
    ]).messengerStore;
    return useMutation({
        mutationKey: [
            "current-brand-context"
        ],
        mutationFn: function(brand) {
            return messengerStore.setCurrentBrandContext(brand);
        }
    });
};
